
const normalizeCustomerName = name =>
  name
    .trim()
    .replace(/ {2,}/g, " ")

export default normalizeCustomerName
